<template>
  <div class="fadeIn">
    <div class="ra-auth--form__header">
      <h6>Verify account</h6>
      <p>
        Input one-time pin (OTP) sent to your <strong>{{ email }}</strong> email
        to verify your account.
      </p>
    </div>
    <div class="ra-auth--form__form">
      <el-form :model="form" label-position="top" ref="form">
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item label="OTP" prop="pin" :rules="validateField()">
              <el-input v-model="form.pin" v-only-number />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="ra-auth--form__actions">
      <el-button :loading="loading" type="primary" @click="verifyOTP"
        >Verify</el-button
      >
      <el-button
        type="primary"
        plain
        :loading="resending"
        :disabled="timer > 0"
        @click="resendOTP"
        >Resend code<span v-if="timer > 0"> - {{ timer }}s</span></el-button
      >
    </div>
  </div>
</template>

<script>
import { resendOtp, currentUser } from "@/lib/utils";
import apiConstants from "@/apiConstants";

export default {
  name: "OtpForm",
  data() {
    return {
      loading: false,
      currentUser: currentUser(),
      email: "",
      form: {
        pin: "",
        token: ""
      },
      timer: null,
      resending: false,
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  methods: {
    startTimer() {
      if (this.timer < 0) {
        return;
      }
      setTimeout(() => {
        this.timer--;
        this.startTimer();
      }, 1200);
    },

    verifyOTP() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.loading = true;
        this.$http
          .post("auth/local/users/verify", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.loading = false;
              this.handleErrors(resData);
            } else {
              this.notification(
                "Verified",
                "OTP verified successfully",
                "success"
              );
              sessionStorage.removeItem("radius-verification-data");
              sessionStorage.setItem(
                "radius-update-data",
                JSON.stringify({
                  auth_token: resData.auth_token,
                  name: resData.user && resData.user.first_name
                })
              );
              this.$router.push({ name: "update-password" });
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    resendOTP() {
      if (!this.form.token) {
        this.$router.push({ name: "login" });
        return;
      }

      this.resending = true;
      this.timer = 10;
      this.startTimer();

      const body = {
        token: this.form.token
      };

      resendOtp(this.$http, body)
        .then(() => {
          this.resending = false;
          this.notification(
            "OTP",
            "A one-time pin (OTP) has been resent to your email for verification",
            "success"
          );
        })
        .catch(err => {
          this.resending = false;
          this.notification("Error", err.message, "danger");
        });
    }
  },

  mounted() {
    const verification = sessionStorage.getItem("radius-verification-data");
    if (!verification) {
      this.notification("Access Denied", "No valid data to verify", "danger");
      this.$router.push({ name: "login" });
      return;
    }

    this.timer = 10;
    this.startTimer();

    const verificationParsed = JSON.parse(verification);
    this.form.token = verificationParsed && verificationParsed.token;
    this.email = verificationParsed && verificationParsed.email;
  },

  beforeRouteEnter(to, from, next) {
    if (currentUser()) {
      this.$router.push({ name: "home.index" });
    } else {
      next();
    }
  }
};
</script>
